import axios from 'axios';
import * as Sentry from '@sentry/react';

const getCPS = async () => {
  const config = {
    method: 'GET',
    url: `${process.env.REACT_APP_BASE_URL}/portal/events/${process.env.REACT_APP_EVENT_ID}/cps/training`,
    headers: {
      'content-type': 'application/json',
    },
  };

  try {
    const { data } = await axios(config);
    return data;
  } catch (error) {
    Sentry.setContext('request', { config });
    Sentry.captureMessage(config.url);
    return [];
  }
};

export { getCPS };
